import { useIntl } from 'react-intl';
import { ActionPriority } from '../../gql/graphql';

export const useActionPriorityOptions = (): {
	priorityOptions: {
		value: ActionPriority;
		text: string;
		color: string;
	}[];
} => {
	const intl = useIntl();

	return {
		priorityOptions: [
			{
				value: 'low',
				text: intl.formatMessage({ id: 'action.priority.low' }),
				color: '#8C8C8C',
			},
			{
				value: 'medium',
				text: intl.formatMessage({ id: 'action.priority.medium' }),
				color: '#FAAD14',
			},
			{
				value: 'high',
				text: intl.formatMessage({ id: 'action.priority.high' }),
				color: '#FF4D4F',
			},
		],
	};
};
